import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59d76d2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "分票统计数据 - (系统自动合成)", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "按箱统计数据 - (系统自动合成)", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "总票统计数据 - (系统自动合成)", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "明细品名及数据", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "VGM数据", -1))
const _hoisted_6 = { class: "form-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td", { width: "70" }),
  /*#__PURE__*/_createElementVNode("td", { width: "140" }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "6",
  class: "label",
  style: {"vertical-align":"middle"}
}, [
  /*#__PURE__*/_createTextVNode(" 发货人"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（Shipper） ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "代码", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "名称", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "地址", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "国家/地区代码", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "电话", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "AEO编码（选填）", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"rgb(242, 222, 222)","color":"blue","font-weight":"bolder","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, " ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "8",
  class: "label",
  style: {"vertical-align":"middle"}
}, [
  /*#__PURE__*/_createTextVNode(" 收货人"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（Consignee） ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "代码", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "名称", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "地址", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "国家/地区代码", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "电话", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "AEO编码（选填）", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "具体联系人", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "联系人电话", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { style: {"background-color":"rgb(242, 222, 222)"} }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, " ")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "6",
  class: "label",
  style: {"vertical-align":"middle"}
}, [
  /*#__PURE__*/_createTextVNode(" 通知人"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（Notifier） ")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "代码", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "名称", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "地址", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "国家/地区代码", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "电话", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label" }, "AEO编码（选填）", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!

  return (_openBlock(), _createBlock(_component_miezz_card, {
    title: "舱单&VGM信息",
    toggle: true,
    down: true,
    topButtons: _ctx.topButtons
  }, {
    default: _withCtx(() => [
      (_ctx.form.Data)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            model: _ctx.form.Data,
            ref: "ruleForm",
            rules: _ctx.form.Rules,
            "label-width": "200px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 8
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "船名",
                            prop: "ShipName"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.MainBill.ShipName ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Sea)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 1,
                        span: 8
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "航次",
                            prop: "VoyageNumber"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.MainBill.VoyageNumber ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Air)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 2,
                        span: 8
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "航班",
                            prop: "Flight"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.MainBill.Flight ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.Data.TransportType == _ctx.EnumTransportType.Railway)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 3,
                        span: 8
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "班次",
                            prop: "RailwayNumber"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.form.Data.MainBill.RailwayNumber ?? "暂无数据"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Port of Delivery/目的港",
                        prop: "DeliveryPortId"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.MainBill.DeliveryPortLabel ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Master Bill No.",
                        prop: "MasterBillNo"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.form.Data.MainBill.MasterBillNo ?? "暂无数据"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_1,
              _createVNode(_component_miezz_page_list, {
                modelValue: _ctx.listProductByCustomsList,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listProductByCustomsList) = $event))
              }, {
                column: _withCtx(({ model, row }) => [
                  _createElementVNode("pre", null, _toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_2,
              _createVNode(_component_miezz_page_list, {
                modelValue: _ctx.listProductByContainerTrailerList,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listProductByContainerTrailerList) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_3,
              _createVNode(_component_miezz_page_list, {
                modelValue: _ctx.listProductByTotalList,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listProductByTotalList) = $event))
              }, {
                column: _withCtx(({ model, row }) => [
                  _createElementVNode("pre", null, _toDisplayString(row[model.Prop] ?? "暂无数据"), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _hoisted_4,
              _createVNode(_component_miezz_page_list, {
                modelValue: _ctx.listProduct,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listProduct) = $event)),
                onHandleRowButtonClick: _ctx.handleProductRowButtonClick
              }, null, 8, ["modelValue", "onHandleRowButtonClick"]),
              _hoisted_5,
              _createVNode(_component_miezz_page_list, {
                modelValue: _ctx.listVgm,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listVgm) = $event)),
                onHandleRowButtonClick: _ctx.handleVgmRowButtonClick
              }, null, 8, ["modelValue", "onHandleRowButtonClick"]),
              _createElementVNode("table", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ShipperCode ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ShipperNameEn ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ShipperAddressEn ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ShipperCountryCode ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_13,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ShipperTel ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_14,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ShipperAeoCode ?? "暂无数据"), 1)
                ]),
                _hoisted_15,
                _createElementVNode("tr", null, [
                  _hoisted_16,
                  _hoisted_17,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ConsigneeCode ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ConsigneeNameEn ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_19,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ConsigneeAddressEn ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ConsigneeCountryCode ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_21,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ConsigneeTel ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_22,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ConsigneeAeoCode ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_23,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ConsigneeContact ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_24,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.ConsigneeContactNumber ?? "暂无数据"), 1)
                ]),
                _hoisted_25,
                _createElementVNode("tr", null, [
                  _hoisted_26,
                  _hoisted_27,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.NotifyPartyCode ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_28,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.NotifyPartyNameEn ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_29,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.NotifyPartyAddressEn ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_30,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.NotifyPartyCountryCode ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_31,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.NotifyPartyTel ?? "暂无数据"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_32,
                  _createElementVNode("td", null, _toDisplayString(_ctx.form.Data.NotifyPartyAeoCode ?? "暂无数据"), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["topButtons"]))
}